import { render, staticRenderFns } from "./modal-prices.vue?vue&type=template&id=31caf0c8&scoped=true&"
import script from "./modal-prices.vue?vue&type=script&lang=js&"
export * from "./modal-prices.vue?vue&type=script&lang=js&"
import style0 from "./modal-prices.vue?vue&type=style&index=0&id=31caf0c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31caf0c8",
  null
  
)

export default component.exports